import update from "immutability-helper";
import { filter, get, includes, concat } from "lodash";
import { INITIATE_EXPAND_ZONE, TOGGLE_ZONE, EXPAND_ZONE, CONTRACT_ZONE } from "../constants/actionTypes";

const zones = (state = {}, action) => {
  let stateSection = get(state, [action.section]);
  if (!stateSection) {
    stateSection = {
      expandedZones: [],
    };
  }
  switch (action.type) {
    case INITIATE_EXPAND_ZONE:
      return update(state, {
        [action.section]: {
          $set: {
            expandedZones: action.expandedZones,
          },
        },
      });
    case TOGGLE_ZONE:
      if (
        includes(
          get(state, [action.section, "expandedZones"]),
          action.zoneId
        )
      ) {
        stateSection = update(stateSection, {
          expandedZones: {
            $set: filter(
              get(state, [action.section, "expandedZones"]),
              (i) => i !== action.zoneId
            ),
          },
        });
      } else {
        stateSection = update(stateSection, {
          expandedZones: {
            $set: concat(get(state, [action.section, "expandedZones"]), [
              action.zoneId,
            ]),
          },
        });
      }
      return update(state, {
        [action.section]: { $set: stateSection },
      });
    case EXPAND_ZONE:
      if (
        !includes(
          get(state, [action.section, "expandedZones"]),
          action.zoneId
        )
      ) {
        stateSection = update(stateSection, {
          expandedZones: {
            $set: concat(get(state, [action.section, "expandedZones"]), [
              action.zoneId,
            ]),
          },
        });
      }
      return update(state, {
        [action.section]: { $set: stateSection },
      });
    case CONTRACT_ZONE:
      if (
        includes(
          get(state, [action.section, "expandedZones"]),
          action.zoneId
        )
      ) {
        stateSection = update(stateSection, {
          expandedZones: {
            $set: filter(
              get(state, [action.section, "expandedZones"]),
              (i) => i !== action.zoneId
            ),
          },
        });
      }
      return update(state, {
        [action.section]: { $set: stateSection },
      });
    default:
      return state;
  }
};

export default zones;
